// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accordion-wrapper{display:flex;flex-direction:column;border:1px solid #d5d5d5;border-radius:4px;padding:16px;margin:16px 0}.accordion-header{display:flex;align-items:center}.accordion-content{margin:8px 0 0 53px}.toggle-icon{display:flex;margin-left:auto;align-items:center;gap:8px}.text-field{margin-top:12px}\n", ""]);
// Exports
module.exports = exports;
